import { z } from "zod/v4";

import { createEndpointBase } from "./core";

const base = "license";
const license = createEndpointBase(base);

export const licenseEndpoints = {
  licenseGet: license({ method: "GET", path: "", request: z.any(), response: z.any() }),
  licenseInstall: license({
    method: "POST",
    path: "id",
    request: z.object({ licenseId: z.string() }),
    response: z.any(),
  }),
} as const;
